import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toIntlDateTimeFormat } from '@zedoc/date';
import Recipient from '../../../../../common/models/Recipient';
import Tooltip from '../../../../../common/components/Tooltip';
import useElementTruncated from '../../../../../utils/useElementTruncated';

const PatientColumn = ({
  recipient,
  projectId,
  patientName,
  patientBirthYear,
}) => {
  const {
    i18n: { language },
  } = useTranslation();
  const { ref, isElementTruncated } = useElementTruncated();

  if (!recipient && !patientName) {
    return null;
  }

  const fullName = recipient ? recipient.getFullName() : '';
  const displayName = fullName || patientName || '';
  const nationalId = recipient && recipient.getNationalId();
  // NOTE: Two different values, deliberately not merged. A recipient the viewer
  //       is assigned to arrives as a full document and shows a full date; one
  //       they are not assigned to arrives as a year only, because that is all
  //       the server sends. Formatting a bare year through a date formatter
  //       would render it as the 1st of January, which is a fact we do not have.
  const birthDate = recipient && recipient.birthDate;
  return (
    <>
      <Tooltip title={isElementTruncated ? displayName : ''}>
        <Link
          ref={ref}
          to={`/patients/${recipient?._id}/projects/${projectId}`}
          // NOTE: "align-top" is used because "inline-block" creates extra blank spacing below the element
          className="truncate inline-block max-w-full align-top text-primary-800 underline hover:no-underline"
        >
          {displayName}
        </Link>
      </Tooltip>
      <p>
        {nationalId && (
          <span>
            {'*******'}
            {' · '}
          </span>
        )}
        <span>
          {birthDate
            ? toIntlDateTimeFormat(language, new Date(birthDate), {
                dateStyle: 'short',
              })
            : patientBirthYear || ''}
        </span>
      </p>
    </>
  );
};

PatientColumn.propTypes = {
  recipient: PropTypes.instanceOf(Recipient),
  projectId: PropTypes.string.isRequired,
  patientName: PropTypes.string,
  patientBirthYear: PropTypes.string,
};

PatientColumn.defaultProps = {
  recipient: null,
  patientName: null,
  patientBirthYear: null,
};

export default PatientColumn;
